/**
 * Checks the window.Cookiebot object if it exists and returns the consented status
 * @returns Boolean
 */
export const getCurrentCookieBotConsentStatus = () => {
    if (typeof window !== 'undefined' && window.Cookiebot) {
        return window.Cookiebot.consented || false;
    }
    return false;
};
/**
 * Checks the window.Cookiebot object if it exists and opens the Cookiebot banner
 */
export const openCookieBotBanner = () => {
    if (typeof window !== 'undefined' && window.Cookiebot) {
        window.Cookiebot.show();
    }
};
